import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { routeBackOfficeCallCenterAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeCallCenterAdminCommon'

const getBackOfficeGroupCallCenterAdmin = [...routeBackOfficeCallCenterAdminCommon].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_PHARMEDICALL_PROCEDURE_ADMIN],
}))

export default getBackOfficeGroupCallCenterAdmin
